import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import EmailTemplatePermission from '../templatePermissionComponent/emailTemplatePermission';
import styles from '../../emailTemplates.less';
import {
  Folders,
  TabSwitcher,
  Templates,
} from '../../component';

const cx = classNames.bind(styles);

const TemplateDetail = ({
  setPermissionSettingVisible,
  isPermissionSettingVisible,
  isSharedByVisible,
  queryByPaging,
  setSelectedFolderData,
  selectedFolder,
  userFolders,
  sharedFolders,
  fetchNewTemplateData,
  isCurrentUser,
}) => (
  // 如果是当前用户，并且是在自己的文件夹的tab下，则可以编辑删除；
  // 如果是当前用户，并且是分享的文件夹tab下，则可以看
  // 其他情况，一律不能编辑，也不能看
  <React.Fragment>
    <Folders
      setSelectedFolderData={setSelectedFolderData}
      selectedFolder={selectedFolder}
      folders={isSharedByVisible ? sharedFolders : userFolders}
      isSharedByVisible={isSharedByVisible}
      queryByPaging={queryByPaging}
    />
    {!isSharedByVisible && isCurrentUser() ?
      <TabSwitcher
        setPermissionSettingVisible={setPermissionSettingVisible}
        isPermissionSettingVisible={isPermissionSettingVisible}
      /> :
      <div className={classNames(cx('template-title'), 'mt-lg full-width')}>
        <FormattedMessage id="page.emailTemplates.templates" />
      </div>
    }
    {isSharedByVisible || !isPermissionSettingVisible || !isCurrentUser() ?
      <Templates
        fetchNewTemplateData={fetchNewTemplateData}
        setPermissionSettingVisible={setPermissionSettingVisible}
        isSharedByVisible={isSharedByVisible}
        isCurrentUser={isCurrentUser}
      /> :
      <EmailTemplatePermission
        isCurrentUser={isCurrentUser}
        selectedFolder={selectedFolder}
      />
    }
  </React.Fragment>
);

export default TemplateDetail;



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/templateDetailComponent/index.js